
import ImagePlugin from './ImagePlugin'

export {
  insertImage
} from './imagePluginHelpers'

export default ImagePlugin
